module.exports = __webpack_public_path__ + "static/media/btn_reset.57900171.svg";